var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64592 1.64689C4.69236 1.60033 4.74754 1.56339 4.80828 1.53818C4.86903 1.51297 4.93415 1.5 4.99992 1.5C5.06568 1.5 5.13081 1.51297 5.19155 1.53818C5.2523 1.56339 5.30747 1.60033 5.35392 1.64689L11.3539 7.64689C11.4005 7.69334 11.4374 7.74852 11.4626 7.80926C11.4878 7.87001 11.5008 7.93513 11.5008 8.00089C11.5008 8.06666 11.4878 8.13178 11.4626 8.19253C11.4374 8.25327 11.4005 8.30845 11.3539 8.35489L5.35392 14.3549C5.26003 14.4488 5.13269 14.5015 4.99992 14.5015C4.86714 14.5015 4.7398 14.4488 4.64592 14.3549C4.55203 14.261 4.49929 14.1337 4.49929 14.0009C4.49929 13.8681 4.55203 13.7408 4.64592 13.6469L10.2929 8.00089L4.64592 2.35489C4.59935 2.30845 4.56241 2.25327 4.5372 2.19253C4.512 2.13178 4.49902 2.06666 4.49902 2.00089C4.49902 1.93513 4.512 1.87001 4.5372 1.80926C4.56241 1.74852 4.59935 1.69334 4.64592 1.64689Z",
    fill: "#F5276F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.b32c7431f64d38fcef29c9b362a95119.svg";
export { ForwardRef as ReactComponent };